import { useState } from "react";

const useAxonForm = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  return [error, setError, isLoading, setIsLoading];
};
export default useAxonForm;
